import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import LayoutCenter from "../components/UserInterface/LayoutCenter";
import NextHead from "../components/Seo/NextHead";
import { homeCreditGoMeta } from "../data/DataMetatags";
import BannerComponent from "../components/UserInterface/BannerComponent";
import Description from "../components/UserInterface/Description";
import { HCGoTerms } from "../components/HomeCreditGo/HCGoTerms";
import { HCGoSteps } from "../components/HomeCreditGo/HCGoSteps";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { HomeCreditGoBreadcrumb, defBreadcrumb } from "../data/DataBreadcrumb";
import VideoComponent from "../components/UserInterface/VideoComponent";
import TestimonialSlider from "../components/UserInterface/Slider/Testimonial/TesimonialSlider";
import { DataTestimonialGoErs } from "../data/go-ers/DataTestimonialGoErs";
import HeadingComponent from "../components/UserInterface/HeadingComponent";
import HCGOBanner from "../../public/static/images/jpg/HCGO_Website-Banner.jpg";
import HCGOMiniBanner from "../../public/static/images/jpg/HCGO_Mini_Web-Banner.jpg";
import UseWindowSize from "../components/UseWindowSize";
import { GACustomEvent } from "src/utils/analytics";

const HomeCreditGo = (props) => {
  const {
    breadcrumb,
    HomeCreditGoBreadcrumb,
    title,
    description,
    path
  } = props;
  const [winSize, setWinSize] = useState(null);
  const { width } = UseWindowSize();
  useEffect(() => {
    GACustomEvent("home_credit_go_page", "view");
    setWinSize(width);
  }, []);

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={HomeCreditGoBreadcrumb} />
      <BannerComponent
        img={winSize > 600 ? HCGOBanner : HCGOMiniBanner}
        visible
        mobileHeight="100%"
      ></BannerComponent>
      <Description
        font="Roboto"
        fontWeight="bold"
        fontSize="23px"
        width="353px"
        text="Yuk gabung jadi Goers dan #TebelinDompet hingga Rp1 juta!"
        fontMobile="18px"
      ></Description>
      <Description
        font="Roboto"
        align="left"
        width="780px"
        margin="8px 16px"
        fontSize="16px"
        fontMobile="14px"
        text="Tahun terus berganti tapi isi kantong selalu sama? Waktunya ganti cara kamu cari cuan, yuk #TebelinDompet lebih mudah dengan gabung jadi Sobat Goers."
      ></Description>
      <Description
        font="Roboto"
        align="left"
        width="780px"
        margin="8px 16px"
        fontSize="16px"
        fontMobile="14px"
        text="Nikmati insentif tiap bulan dari kode referalmu yang berhasil digunain mereka yang belanja lewat pembiayaan Home Credit."
      ></Description>
      <Description
        font="Roboto"
        align="left"
        width="780px"
        margin="8px 16px 64px 16px"
        marginMobile="8px 16px 32px 16px"
        fontSize="16px"
        fontMobile="14px"
        text="Cuma modal jari dan tidak perlu terikat, cuan kamu bisa berlipat. Jadi, tunggu apa lagi? Saatnya gabung menjadi bagian dari 100 Ribu sobat Goers."
      ></Description>
      <LayoutCenter margin="0px">
        <div className="video-container">
          <VideoComponent
            src="https://www.youtube.com/embed/_0fMHHhU8PA"
            videoWidth="100%"
          />
        </div>
      </LayoutCenter>

      <LayoutCenter
        margin="32px 16px 64px"
        column
        marginMobile="16px 16px 16px"
      >
        <HeadingComponent
          margin="0 16px 12px"
          marginHeadingMobile="0 16px 0"
          headingText="Testimoni"
          fontWeight="bold"
        />
        <TestimonialSlider items={DataTestimonialGoErs} />
      </LayoutCenter>
      <HCGoTerms />
      <HCGoSteps />
      <style jsx>
        {`
          .video-container {
            max-width: 640px;
            width: 100%;
            height: 340px;
            margin: 0 0 64px 0;
          }
          @media only screen and (max-width: 630px) {
            .video-container {
              height: auto;
              margin: 0;
            }
          }
        `}
      </style>
    </Layout>
  );
};

export const getStaticProps = async () => {
  const { title, description, path } = homeCreditGoMeta;
  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];

  return {
    props: {
      breadcrumb,
      HomeCreditGoBreadcrumb,
      title,
      description,
      path
    }
  };
};

export default HomeCreditGo;
